const SPLIT_TESTS_FAVORITES = 'splitTests.favorites';
const SPLIT_TESTS_FILTERS = 'splitTests.filters';
export const getFavorites = () => {
    return JSON.parse(localStorage.getItem(SPLIT_TESTS_FAVORITES) || '[]');
};
export const storeFavorites = (favorites) => {
    localStorage.setItem(SPLIT_TESTS_FAVORITES, JSON.stringify(favorites));
};
export const getFilters = () => {
    const filters = localStorage.getItem(SPLIT_TESTS_FILTERS);
    if (filters) {
        return JSON.parse(filters);
    }
    return {
        showFavorites: false,
        showApplied: false,
        filteredType: '',
        state: '',
    };
};
export const storeFilters = (filters) => {
    localStorage.setItem(SPLIT_TESTS_FILTERS, JSON.stringify(filters));
};
//# sourceMappingURL=splitTestsStorage.js.map